
const columns = () => {
  return [
    {
      title: "培训中心名称",
      name: "name",
      searchItem: {},
      tableItem: {
        width: 300,
      }
    },
    {
      title: "地址",
      name: "address",
      tableItem: {
        width: 400,
      }
    },
    {
      title: "创建时间",
      name: "createTime",
      tableItem: { 
        width: 400,
      }
    }
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'trainCenterForTableForm/list',
    ...api
  }
}

const trainCenter = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'id',
    rowName: 'name',
    columns: columns(),
    cols: {
      xs: 12,
      md: 12,
      xl: 12
    },
    tableApi: tableApi(api)
  }
}

export default trainCenter